<div id="root-div">
  <router-outlet></router-outlet>
  <app-toasts></app-toasts>
  <ngx-loading-bar color="#000" [height]="'3px'" [includeSpinner]="false" ref="http"></ngx-loading-bar>
  <app-cookie-consent
    *ngIf="cookieConsentGiven !== true && cookieConsentGiven !== false && isBrowser"
  ></app-cookie-consent>
</div>
